import { path, pipe } from 'ramda';

export const getCard = path(['register', 'payment', 'card']);
export const getHasCard = pipe(getCard, Boolean);
